import React, { Component } from 'react';
import './editalumni.css';
import { Row, Col, Form, Select, Button, DatePicker, Input, Modal } from 'antd';
import moment from 'moment';
import * as actions from '../../actions/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import warningAlert from "../BulkUpload/warning-alert.png";

const FormItem = Form.Item;
const Option = Select.Option;

// AAG-1378: Enroll an alumnus into a non-revenue NESA membership (e.g. granted 5-Year/Lifetime
// levels that don't go through the standard purchase flow).
const NESA_5_YEAR_LEVEL_ID = '30';
const NESA_LIFETIME_LEVEL_ID = '32';

class NESAAddMembership extends Component {

    constructor(props) {
        super(props)
        this.state = {
            selectedLevel: undefined,
            effectiveDate: null,
            expireDate: null,
            hasConflict: false,
            isShowConflictPopUp: false,
        }
    }

    componentDidMount = () => {
        if (!this.props.nesa_levels) {
            this.props.actions.getNESAmembershiplevels()
        }
    }

    componentDidUpdate = (prevProps) => {
        if (!prevProps.added && this.props.added) {
            this.resetForm();
            return;
        }
        if (prevProps.nesa_reg !== this.props.nesa_reg && this.state.selectedLevel && this.state.selectedLevel.toString() === NESA_5_YEAR_LEVEL_ID) {
            this.applyFiveYearDefaultEffectiveDate();
        }
    }

    resetForm = () => {
        this.props.form.resetFields();
        this.setState({
            selectedLevel: undefined,
            effectiveDate: null,
            expireDate: null,
            hasConflict: false,
            isShowConflictPopUp: false,
        });
    }

    computeExpireDate = (levelId, effectiveDate) => {
        if (!levelId || !effectiveDate) return null;
        if (levelId.toString() === NESA_LIFETIME_LEVEL_ID) return null;
        if (levelId.toString() === NESA_5_YEAR_LEVEL_ID) return moment(effectiveDate).add(5, 'years').subtract(1, 'day');
        return null;
    }

    // AAG-1378: default the Effective Date to the day after the latest expiring existing
    // membership (of any level), mirroring the legacy getMembershipsMaxDate behavior.
    getLatestExpireDate = () => {
        const nesaReg = this.props.nesa_reg;
        if (!Array.isArray(nesaReg) || nesaReg.length === 0) return null;
        const expireDates = nesaReg.filter(reg => reg.expireDate).map(reg => moment(reg.expireDate));
        if (expireDates.length === 0) return null;
        return moment.max(expireDates);
    }

    applyFiveYearDefaultEffectiveDate = () => {
        const latestExpireDate = this.getLatestExpireDate();
        if (!latestExpireDate) return;
        const today = moment();
        // AAG-1378: if the last expiration date is already in the past, default to today
        // instead of a past date (mirrors the legacy showMembershipModal behavior).
        const defaultEffectiveDate = today.isBefore(latestExpireDate) ? moment(latestExpireDate).add(1, 'day') : today;
        const expireDate = this.computeExpireDate(this.state.selectedLevel, defaultEffectiveDate);
        this.setState({
            effectiveDate: defaultEffectiveDate,
            expireDate
        }, () => {
            this.checkNesaRegistrationConflicts(defaultEffectiveDate, expireDate);
        });
        this.props.form.setFieldsValue({ nesa_add_effective_date: defaultEffectiveDate });
    }

    showConflictPopUpModal = () => {
        this.setState({ isShowConflictPopUp: true });
    }

    closeConflictPopUpModal = () => {
        this.setState({ isShowConflictPopUp: false });
    }

    // AAG-1378: mirrors Memberships.js#checkNesaRegistrationConflicts — flags a 5-Year Effective
    // Date whose [effectiveDate, expireDate] range overlaps an existing NESA registration, whether
    // that registration is currently active or scheduled to start in the future.
    checkNesaRegistrationConflicts = (proposedStartDate, proposedEndDate) => {
        const nesaReg = this.props.nesa_reg;
        const isConflicted = Array.isArray(nesaReg) && !!nesaReg.find(reg => {
            const effectiveDate = moment(reg.effectiveDate);
            const expiryDate = moment(reg.expireDate);

            return (
                !effectiveDate.isSame(expiryDate) &&
                ((moment(proposedStartDate).isSameOrAfter(effectiveDate) && moment(proposedEndDate).isBefore(expiryDate)) ||
                (moment(proposedStartDate).isSameOrBefore(expiryDate) && effectiveDate.isBefore(moment(proposedEndDate))))
            );
        });

        if (isConflicted) {
            this.showConflictPopUpModal();
        }
        this.setState({ hasConflict: !!isConflicted });
        return !!isConflicted;
    }

    renderNesaLevels = () => {
        if (this.props.nesa_levels) {
            return this.props.nesa_levels.map((k) => {
                return <Option key={k.id} value={k.id}>{(k.name).replace(/-/g, " ")}</Option>
            })
        }
    }

    handleLevelChange = (value) => {
        const expireDate = this.computeExpireDate(value, this.state.effectiveDate);
        this.setState({
            selectedLevel: value,
            expireDate,
            hasConflict: false
        }, () => {
            if (value && value.toString() === NESA_5_YEAR_LEVEL_ID) {
                this.applyFiveYearDefaultEffectiveDate();
            }
        })
    }

    handleEffectiveDateChange = (date) => {
        const expireDate = this.computeExpireDate(this.state.selectedLevel, date);
        this.setState({
            effectiveDate: date,
            expireDate,
            hasConflict: false
        }, () => {
            if (date && this.state.selectedLevel && this.state.selectedLevel.toString() === NESA_5_YEAR_LEVEL_ID) {
                this.checkNesaRegistrationConflicts(date, expireDate);
            }
        })
    }

    handleSubmit = (e) => {
        e.preventDefault();
        if (this.state.hasConflict) {
            this.showConflictPopUpModal();
            return;
        }
        this.props.form.validateFieldsAndScroll((err) => {
            if (!err) {
                const profile = this.props.profileinfo && this.props.profileinfo.profile;
                const { eagleinfo } = this.props;
                const memberIdsMatch = profile && eagleinfo && Number(profile.memberId) === Number(eagleinfo.memberId);
                const boardReviewDate = memberIdsMatch ? eagleinfo.eagleBoardReviewDate : null;
                this.props.actions.addNonRevenueNESAMembership(this.props.personGUID, this.state.selectedLevel, this.state.effectiveDate, profile, boardReviewDate);
            }
        })
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const canSubmit = !!this.state.selectedLevel && !!this.state.effectiveDate && !this.state.hasConflict && !this.props.adding;
        return <Form onSubmit={this.handleSubmit}>
            <Row type="flex" justify="space-between" align="start">
                <FormItem label="">
                    <input type="hidden" />
                </FormItem>
                <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                    <FormItem label="NESA Membership Level:">
                        {getFieldDecorator('nesa_add_level', {
                            rules: [{ required: true, message: 'Please select a NESA Membership level!' }],
                        })(
                            <Select
                                style={{ width: '100%' }}
                                placeholder="Select level"
                                onChange={this.handleLevelChange}
                            >
                                {this.renderNesaLevels()}
                            </Select>
                        )}
                    </FormItem>
                </Col>
                <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                    <FormItem label="Effective Date:">
                        {getFieldDecorator('nesa_add_effective_date', {
                            rules: [{ required: true, message: 'Please select an Effective Date!' }],
                        })(
                            <DatePicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                                className="width-100"
                                onChange={this.handleEffectiveDateChange}
                            />
                        )}
                    </FormItem>
                </Col>
                <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                    <FormItem label="Expire Date:">
                        <Input
                            disabled
                            value={this.state.expireDate ? this.state.expireDate.format('MM/DD/YYYY') : ''}
                            placeholder="No Expiration"
                            className="ant-input width-100"
                        />
                    </FormItem>
                </Col>
                <Col className="center" xs={24} sm={24} md={3} lg={3} xl={3} style={{ margin: "25px 0px" }} />
                <Col className="center" xs={24} sm={24} md={5} lg={5} xl={5} style={{ margin: "25px 0px" }}>
                    <FormItem>
                        <Button
                            id="add-nesa-non-revenue-membership"
                            className="ant-btn-primary"
                            htmlType="submit"
                            loading={this.props.adding}
                            disabled={!canSubmit}
                        > ADD MEMBERSHIP </Button>
                    </FormItem>
                </Col>
            </Row>
            <Modal
                className="No-records-Found-model"
                title=""
                visible={this.state.isShowConflictPopUp}
                centered
                footer={false}
                closable={false}
                onCancel={this.closeConflictPopUpModal}
            >
                <div className="center">
                    <div>
                        <img src={warningAlert} alt="warning" width="40px" height="40px" />
                    </div>
                    <div className="margin-bottom-20" style={{ marginTop: "20px" }}>
                        The attempted membership's start date adjustment conflicts with an existing membership.
                        Please review the other memberships for this member and make appropriate adjustments
                        to avoid overlapping dates.
                    </div>
                    <Button
                        key="close" type="primary"
                        style={{ backgroundColor: '#003366', borderColor: '#fff', borderRadius: '28px', padding: '15px 35px 34px 35px' }}
                        onClick={this.closeConflictPopUpModal} >
                        CLOSE
                    </Button>
                </div>
            </Modal>
        </Form>
    }
}

function mapStateToProps(state) {
    return {
        nesa_levels: state.nesalevelsreducer.levels,
        adding: state.nesaNonRevenueMembershipAddReducer.loading,
        added: state.nesaNonRevenueMembershipAddReducer.added,
        profileinfo: state.alumniinforeducer.profileinfo,
        eagleinfo: state.alumnieagleinforeducer.eagleinfo,
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(actions, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(NESAAddMembership));



// WEBPACK FOOTER //
// ./src/components/MaintainAlumni/NESAAddMembership.js